import { useQuery } from '../../lib/query';
import { Link } from '../../lib/router';
import { placesCrud } from './placesConfig';

// Read-only detail view for a place. id from route params (via App.js).
export default function PlaceDetailPage({ params }) {
  const { data: place, isLoading, error } = useQuery({
    queryKey: ['places', params.id],
    queryFn: () => placesCrud.get(params.id),
  });

  if (isLoading) return <div className="state state--loading">Loading…</div>;
  if (error) return <div className="state state--error" role="alert">{error.message}</div>;
  if (!place) return null;

  return (
    <div className="page">
      <div className="page__header">
        <h1>{place.name}</h1>
        <Link to="/places" className="btn btn--ghost">← Back</Link>
      </div>
      <div className="detail-grid">
        {place.imageUrl && <img className="detail-grid__img" src={place.imageUrl} alt={place.name} />}
        <div className="detail">
          <p><strong>Category:</strong> {place.category || '—'}</p>
          <p><strong>State ID:</strong> {place.stateId || '—'}</p>
          <p><strong>Rating:</strong> {place.rating ?? '—'}</p>
          <p><strong>Popular:</strong> {place.isPopular ? 'Yes' : 'No'}</p>
          <p><strong>Coordinates:</strong> {place.latitude ?? '—'}, {place.longitude ?? '—'}</p>
          <p><strong>Tags:</strong> {Array.isArray(place.tags) ? place.tags.join(', ') : place.tags || '—'}</p>
          <p><strong>Description:</strong></p>
          <p>{place.description || '—'}</p>
        </div>
      </div>
    </div>
  );
}
